import React,{useState} from 'react'
import './Navbar.css'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import axios from 'axios';

const Navbar = (props) => {

  const [userName, setUserName] = useState(localStorage.getItem("username"));
  const [userRole, setUserRole] = useState(localStorage.getItem("userrole"));
  const [timestamp, setTimestamp] = useState(localStorage.getItem("timestamp"));
  const [userPhoto, setUserPhoto] = useState(localStorage.getItem("userphoto"));

  const logout = () => {
    localStorage.clear();
    window.location.href = '/';
  }
  return (
    <div className="navbar">
      <div className="wrapper">
          <div className="items">
            <div className="item">
              <span className="module-title">{props.title}</span>
            </div>
          </div>
          <div className="items">
          {/* <div className="item">
              <NotificationsActiveIcon className="icon"/>
              <div className="counter">2</div>
            </div> */}
          <div className="item">
            <img
              src={axios.defaults.baseURL + "/" + userPhoto}
              alt={userName}
              className="avatar"
            />
            <span>{userName}</span>
          </div>
          <div className="item" onClick={logout}><PowerSettingsNewIcon className="icon"/> <span>Logout</span></div>
          </div>
      </div>
    </div>
  )
}

export default Navbar